module.exports = __webpack_public_path__ + "img/selfcheckout-downgrade.6089bc5a.png";